import { render, staticRenderFns } from "./DbImg.vue?vue&type=template&id=50960bfb&"
import script from "./DbImg.vue?vue&type=script&lang=ts&"
export * from "./DbImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports